/**
 * Cards entité – bloc .block-cards_entite, ScrollTrigger pin au scroll (desktop)
 * Spacing = titleHeight + 60 (cumulé), chaque carte se place sous le picto précédent.
 * Butée légèrement avant pour garder une marge en bas (END_MARGIN).
 * Plusieurs blocs gérés ; pas de taille en dur, valable pour 3, 5, 7+ cartes.
 * Dépendances globales : jQuery, gsap, ScrollTrigger
 */
(function () {
	'use strict';

	jQuery(function () {
		var containers = document.querySelectorAll('.block-cards_entite');
		if (!containers.length) return;

		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
		gsap.registerPlugin(ScrollTrigger);

		var mm = gsap.matchMedia();
		mm.add('(min-width: 820px)', function () {
			var END_MARGIN = 80; // marge sous la dernière carte avant la butée (évite d’être collé au bloc suivant / footer)

			containers.forEach(function (container) {
				var cards = gsap.utils.toArray('.card_entite-elem', container);
				if (!cards.length) return;

				var spacing = [];
				var cardHeights = [];
				var totalHeight = 0;
				var cardH;

				function refreshSpacing() {
					var space = 0;
					totalHeight = 0;
					cards.forEach(function (card, i) {
						var cardHeight = card.offsetHeight;
						cardHeights[i] = cardHeight;
						var titleEl = card.querySelector('.card_entite-title');
						var titleHeight = titleEl ? titleEl.offsetHeight : 60;
						spacing[i] = space += titleHeight + 60;
						totalHeight += cardHeight;
					});
					spacing.total = space;
				}

				// Règle basée sur les cartes : end = base + spacingTotal − marge.
				function getEndValue() {
					var n = cards.length;
					if (!n) return 0;
					if (!totalHeight) refreshSpacing();
					var spacingTotal = (spacing.length > 0 ? spacing[spacing.length - 1] : 0) || spacing.total || 0;
					if (!spacingTotal) {
						for (var s = 0, i = 0; i < n; i++) {
							var t = cards[i].querySelector('.card_entite-title');
							s += (t ? t.offsetHeight : 60) + 60;
							spacingTotal = s;
						}
					}
					var avgCardH = totalHeight / n;
					var base = avgCardH * 1.3;
					return Math.max(0, base + spacingTotal - END_MARGIN);
				}

				function runScrollTriggerSetup() {
					refreshSpacing();
					cardH = jQuery(cards[0]).outerHeight();
					cards.forEach(function (card, index) {
						ScrollTrigger.create({
							trigger: card,
							start: function () { return 'top-=' + (spacing[index] || 0) + ' top+=0'; },
							endTrigger: container,
							end: function () { return 'bottom-=' + getEndValue() + ' top+=0'; },
							pin: true,
							pinSpacing: false,
							markers: false,
							invalidateOnRefresh: true,
							onRefresh: function () {
								var newCardH = jQuery(cards[0]).outerHeight();
								if (newCardH) cardH = newCardH;
								refreshSpacing();
							}
						});
					});
				}

				var images = container.querySelectorAll('img');
				var totalImages = images.length;
				var loadedCount = 0;
				var done = false;
				function maybeRun() {
					if (done) return;
					if (loadedCount >= totalImages) {
						done = true;
						requestAnimationFrame(function () {
							requestAnimationFrame(runScrollTriggerSetup);
						});
					}
				}
				if (totalImages === 0) {
					runScrollTriggerSetup();
				} else {
					images.forEach(function (img) {
						if (img.complete && img.naturalWidth > 0) {
							loadedCount++;
							maybeRun();
						} else {
							img.addEventListener('load', function onLoad() {
								loadedCount++;
								img.removeEventListener('load', onLoad);
								maybeRun();
							});
							img.addEventListener('error', function onErr() {
								loadedCount++;
								img.removeEventListener('error', onErr);
								maybeRun();
							});
						}
					});
					setTimeout(function () {
						if (!done) {
							done = true;
							runScrollTriggerSetup();
						}
					}, 4000);
				}
			});

			window.addEventListener('resize', function () { ScrollTrigger.refresh(); });
		});
	});
})();
